<template lang="pug">
section
  s-page-title(title='Видеокамеры')
    template(slot='extension')
      s-sort-button(@click='sorting.opened = true' class='mr-3')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
      template(slot='controls')
        v-layout
          v-flex(xs-12)
            s-complex-picker(
              :value='dataFilter.complex_id'
              @change='changeComplex'
              clearable
            )
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      :pagination='dataFilter'
      @update:pagination='updatePagination'
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td 
            v-tooltip(top v-if='props.item.is_timelapsed===1')
              template(v-slot:activator="{ on }")
                v-icon(small v-on="on") camera_alt
              span Снимаются скриншоты
          td
            v-img(
              v-if='props.item.last_screenshot'
              :lazy-src='props.item.last_screenshot'
              :src='props.item.last_screenshot'
              class='grey lighten-4'
              contain
            )
              v-layout(slot='placeholder')
                v-progress-circular(indeterminate color='primary')
          td {{ props.item.name }}
          td {{ props.item.cam_code }}
          td {{ props.item.linia_number }}
          td
            a(:href='"https://unistroyrf.ru/timelaps/"+props.item.id' target='_blank'  @click.stop=true v-if='props.item.published')
                          | Смотреть
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='updateListItem'
              resource='cameras'
            )
  s-sorting-list(v-model='sorting' @sort-success='fetch')
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#',
        align: 'left',
        value: 'is_timelapsed',
        width: '2%',
        sortable: true
      },
      {
        text: 'Превью',
        align: 'left',
        value: 'last_screenshot',
        width: '20%',
        sortable: false
      },
      {
        text: 'Название',
        align: 'left',
        value: 'name',
        width: '70%',
        sortable: true
      },
      {
        text: 'Код',
        align: 'left',
        value: 'cam_code',
        width: '33%',
        sortable: true
      },
      {
        text: 'Номер в линии',
        align: 'left',
        value: 'linia_number',
        width: '5%',
        sortable: true
      },
      {
        text: 'Таймлапс',
        width: '10%',
        sortable: false
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ],
    sorting: {
      opened: false,
      resource: 'cameras',
      itemValue: 'id',
      itemText: 'name',
      groupBy: 'complex_name'
    }
  }),

  created() {
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter(pagination)
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Admin.Cameras.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({ config: { params: this.dataFilter } })
    },

    async onDelete({ id }) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await this.destroy({ id })
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    updateListItem(data) {
      this.updateSuccess({ data })
    },

    changeComplex(complexId = null) {
      this.setDataFilter({ complex_id: complexId })
      this.fetch()
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('admin/cameras', ['fetchList', 'destroy']),
    ...mapMutations('admin/cameras', ['setDataFilter', 'updateSuccess'])
  },

  computed: {
    ...mapState('admin/cameras', ['total', 'dataFilter']),
    ...mapGetters('admin/cameras', ['list', 'isLoading'])
  }
}
</script>
